<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <div class="row form-group">
        <div class="col-md-12">
          <base-button type="danger" @click="volver()">Volver</base-button>
        </div>
      </div>
      <b-card-header header-tag="header" class="p-1" role="tab">Redes asociadas</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in proveedoresAsignados"
                v-bind:key="item.SupplierID"
                :value="item.SupplierID"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
              >
                <div class="col-10" style="display: flex;cursor: pointer">
                  <img :src="item.Image" class="rounded-circle" style="width: 50px" alt />
                  <div style="margin-left: 10px;margin-top: 10px;">
                    <div>{{item.SupplierName}}</div>
                  </div>
                </div>
                <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">
                  <i @click="borrar(item)" class="fa fa-fw fa-trash" style></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Asignar red</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <!-- <KitsCombo
              v-model="proveedorID"
              v-bind:items="proveedores"
              propertyName="BusinessName"
              propertyID="EntityID"
              nullText=" -- Seleccione un proveedor -- "
              :todos="true"
              :change="updateLabel(this)"
            ></KitsCombo>-->
            <label>Busque la red</label>
            <KitsBusqueda
              url="Supplier/GetSuppliersForControlBusquedaVUE"
              :showOnlyText="true"
              ref="busquedaproveedores"
              placeholder="Ingrese el Nombre ..."
              v-model="Supplier"
              :currentValue="Supplier"
            />
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>{{refLabel}}</label>
            <base-input v-model="valorreferencia"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div
            class="col-md-12"
            style="background-color: #FFF2CC; padding-top: 15px; padding-bottom: 10px; text-align: center; border: 1px solid black;"
          >
            <label>Debe ingresar el valor que identifica su cuenta en la red, por ejemplo número de cliente, CUIT, referencia de pago, etc.</label>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <save-button text="Asignar" @click="asignar"></save-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import store from "@/store";

// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";
import confirmHelper from "@/helpers/confirmHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";
import KitsBusqueda from "@/components/KitsBusqueda";
import { stringify } from "querystring";

export default {
  components: { KitsCombo, KitsBusquedaSimple, KitsBusqueda },
  data() {
    return {
      proveedoresAsignados: [],
      valorreferencia: "",
      refLabel: "Valor de referencia",
      Supplier: null
    };
  },
  methods: {
    borrar(item) {
      let context = this;

      // -- Confirmacion
      confirmHelper.showConfirm(
        "¿Esta seguro que desea eliminar la relación proveedor?",
        this,
        function() {
          // -- En caso que la confirmacion sea aceptada
          axiosHelpers.axiosPost(
            "Account/DisableAccountSupplier",
            { SupplierID: item.SupplierID },
            context,
            function(data) {
              if (data.ResponseVM.Success) {
                notificationHelpers.showSuccess(
                  "Exito",
                  "Se desasignó el proveedor correctamente",
                  context
                );
                context.cargarAsignados();
              }
            }
          );
          // --
        }
      );
    },
    cargarAsignados() {
      let context = this;
      axiosHelpers.axiosPost(
        "Account/GetSuppliersByAccountID",
        {},
        this,
        function(data) {
          console.log(JSON.stringify(data.ResponseVM.Items));
          context.proveedoresAsignados = data.ResponseVM.Items;
        }
      );
    },
    volver() {
      this.$router.push("pagoproveedor");
    },
    asignar() {
      let context = this;
      if (context.valorreferencia == "" || context.Supplier.EntityID == null) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Debe completar todos los campos",
          context
        );
        return;
      }

      axiosHelpers.axiosPost(
        "Account/CreateAccountSupplier",
        {
          SupplierID: context.Supplier.EntityID,
          ReferenceValue: context.valorreferencia,
          SearchFromAccount: true
        },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            notificationHelpers.showSuccess(
              "Exito",
              "Se asignó el proveedor correctamente",
              context
            );
            context.Supplier = null;
            context.$refs.busquedaproveedores.limpiarControlBusqueda();
            // context.$refs.controlBusqueda.limpiarControlBusqueda;
            context.valorreferencia = "";
            context.cargarAsignados();
          }
        }
      );
    }
  },
  beforeMount: function() {
    let context = this;

    this.cargarAsignados();
  }
};
</script>